export function notNullUndef<T>(x: T | null | undefined): x is T {
  if (x === null) return false;
  if (x === undefined) return false;
  return true;
}
export default notNullUndef;
